import { mapActions } from 'vuex'

import {
  getRedmineUser,
  getProject,
  registerMembershipIfNeeded,
  didUserLoginRedmine
} from '../service'

import {
  USER
} from 'src/store/definition'

import {
  roleName,
  redmineUser,
  project,
  initialize
} from './definition'

export default {
  [initialize] ({ getters, commit }) {
    return new Promise((resolve, reject) => {
      if (!getters[redmineUser]) {
        Promise.all(
          [
            getRedmineUser(getters[USER]),
            getProject()
          ]
        ).then(results => {
          registerMembershipIfNeeded({
            redmineUser: results[0],
            project: results[1],
            roleName: getters[roleName]
          }).then(redmineUserDetail => {
            commit(redmineUser, redmineUserDetail)
            commit(project, results[1])
            didUserLoginRedmine({ redmineUser: redmineUserDetail })
            resolve()
          }).catch(({ message }) => {
            reject({ message })
          })
        }).catch(({ message }) => {
          reject({ message })
        })
      } else {
        resolve()
      }
    })
  }
}

export const actions = mapActions({
  initialize
})



// WEBPACK FOOTER //
// ./src/components/sourcing-workflow/service-request/store/actions.js